import BaseApiClient from "./base-client";
class StudyUsersApi extends BaseApiClient {
    CROSS_STUDY_USERS_PATH = "/api/study-users";
    STUDY_USERS_BASE_PATH = "/api/studies";
    getUserById = async ({ userId }, studyId) => {
        return this.get(`${this.getEndpoint(studyId)}/${userId}`);
    };
    getUsers = async (userIds, studyId) => {
        const endpoint = this.getEndpoint(studyId);
        return this.get(`${endpoint}`, {
            params: { userIds }
        });
    };
    getUsersForStudy = async (studyId) => {
        return this.get(`${this.getEndpoint(studyId)}`);
    };
    getEndpoint = (studyId) => {
        return studyId ? `${this.STUDY_USERS_BASE_PATH}/${studyId}/users` : this.CROSS_STUDY_USERS_PATH;
    };
    static instance = new StudyUsersApi();
}
export default StudyUsersApi.instance;
